import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import {TrusteeContactType} from '@lifeislife/lifeislife-domain';
import {TrusteeContactTypeItemsService} from '../trustee-contact-type-items.service';
import {EnumUtils} from '../../../util/enum-utils';

@Component({
  selector: 'app-trustee-contact-type-select',
  templateUrl: './trustee-contact-type-select.component.html',
  styleUrls: ['./trustee-contact-type-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TrusteeContactTypeSelectComponent),
    multi: true,
  }],
})
export class TrusteeContactTypeSelectComponent implements OnInit, ControlValueAccessor {


  @Input()
  disabled = false;
  @Input()
  hasError = false;
  @Input()
  allOptions: TrusteeContactType[] = EnumUtils.listEnumMembers(TrusteeContactType);

  allItems: SelectItem[];
  selectedValue: TrusteeContactType;

  private onChangeFunction: Function;
  private onTouchedFunction: Function;

  constructor(private itemService: TrusteeContactTypeItemsService) {
  }

  ngOnInit() {
    this.allItems = this.itemService.createAllTrusteeContactTypeItems();
  }

  writeValue(obj: TrusteeContactType): void {
    this.selectedValue = obj;
  }

  registerOnChange(fn: any): void {
    this.onChangeFunction = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFunction = fn;
  }

  onChange(event: TrusteeContactType) {
    this.selectedValue = event;
    this.fireChange();
  }


  fireChange() {
    this.onTouchedFunction();
    this.onChangeFunction(this.selectedValue);
  }

}
